
import { Routes, RouterModule } from '@angular/router';


import {HomeComponent} from '../../components/public/home/home.component';
import { PQRSComponent } from '../../components/public/pqrs/pqrs.component';




// Cogui
import { CoguiComponent } from '../../components/public/Cogui/cogui/cogui.component';

// Fundamentos de Cogui
import { QueEsCoguiComponent } from '../../components/public/Cogui/Fundamentos/que-es-cogui/que-es-cogui.component';
import { NuestrosSimbolosComponent } from '../../components/public/Cogui/Fundamentos/nuestros-simbolos/nuestros-simbolos.component';
import { ManualDeCalidadComponent } from '../../components/public/Cogui/Fundamentos/manual-de-calidad/manual-de-calidad.component';
import { PoliticaYObjetivosDeCalidadComponent } from '../../components/public/Cogui/Fundamentos/politica-yobjetivos-de-calidad/politica-yobjetivos-de-calidad.component';
import { GestionDelCambioComponent } from '../../components/public/Cogui/Fundamentos/gestion-del-cambio/gestion-del-cambio.component';
import { MapaDeProcesosComponent } from '../../components/public/Cogui/Fundamentos/mapa-de-procesos/mapa-de-procesos.component';
import { MapaDeRiesgosComponent } from '../../components/public/Cogui/Fundamentos/mapa-de-riesgos/mapa-de-riesgos.component';
import { ModelosAplicablesComponent } from '../../components/public/Cogui/Fundamentos/modelos-aplicables/modelos-aplicables.component';
import { NormogramaInstitucionalComponent } from '../../components/public/Cogui/Fundamentos/normograma-institucional/normograma-institucional.component';
import { PoliticaDeIntegridadYBuenGobiernoComponent } from '../../components/public/Cogui/Fundamentos/politica-de-integridad-y-buen-gobierno/politica-de-integridad-y-buen-gobierno.component';
import { CertificadoDeCalidadNTCGComponent } from '../../components/public/Cogui/Fundamentos/certificado-de-calidad-ntcg/certificado-de-calidad-ntcg.component';
import { CertificadoDeCalidadISOComponent } from '../../components/public/Cogui/Fundamentos/certificado-de-calidad-iso/certificado-de-calidad-iso.component';
import { ContactenosComponent } from '../../components/public/Cogui/contactenos/contactenos.component';
import { DocumentosComponent } from 'src/app/components/public/Cogui/documentos/documentos.component';

import { TramitesYServiciosComponent } from 'src/app/components/public/tramites-yservicios/tramites-yservicios.component';
import { TramitesCiudadanoComponent } from 'src/app/components/public/tramites-yservicios/tramites-ciudadano/tramites-ciudadano.component';
import { DetalleTramiteCComponent } from 'src/app/components/public/tramites-yservicios/detalle-tramite-c/detalle-tramite-c.component';
import { CertificadoCalidadNTCComponent } from '../../components/public/Cogui/Fundamentos/certificado-calidad-ntc/certificado-calidad-ntc.component';

import { PqrsConsultarComponent } from 'src/app/components/public/pqrs/consultar-pqrs/pqrs-consultar.component';
import { TramiteConsultaComponent } from '../../components/public/tramites-yservicios/tramite-consulta/tramite-consulta.component';
import { SistemaCoguiComponent } from 'src/app/components/public/Cogui/sistema-cogui/sistema-cogui.component';

//Paso a paso de Cogui
import { SensibilizacionYCapacitacionComponent } from '../../components/public/Cogui/paso-a-paso/sensibilizacion-y-capacitacion/sensibilizacion-y-capacitacion.component';
import { LogrosComponent } from '../../components/public/Cogui/paso-a-paso/logros/logros.component';
import { CertificadosCalidadComponent } from 'src/app/components/public/Cogui/Fundamentos/certificados-calidad/certificados-calidad.component';
import { LoginComponent } from 'src/app/components/login/login.component';
import { EncuestaPqrsComponent } from 'src/app/components/public/encuesta-pqrs/encuesta-pqrs.component';


export const PUBLIC_ROUTES: Routes = [

    { path: '', component: HomeComponent, pathMatch: 'full' },
    { path: 'PQRS', component: PQRSComponent, pathMatch: 'full' },
   
    { path: 'Cogui', component: CoguiComponent, pathMatch: 'full' },
    { path: 'QueEsCogui', component: QueEsCoguiComponent, pathMatch: 'full' },
    { path: 'NuestrosSimbolos', component: NuestrosSimbolosComponent, pathMatch: 'full' },
    { path: 'ManualDeCalidad', component: ManualDeCalidadComponent, pathMatch: 'full' },
    { path: 'PoliticaYObjetivosDeCalidad', component: PoliticaYObjetivosDeCalidadComponent, pathMatch: 'full' },
    { path: 'GestionDelCambio', component: GestionDelCambioComponent, pathMatch: 'full' },
    { path: 'MapaDeProcesos', component: MapaDeProcesosComponent, pathMatch: 'full' },
    { path: 'MapaDeRiesgos', component: MapaDeRiesgosComponent, pathMatch: 'full' },
    { path: 'ModelosAplicables', component: ModelosAplicablesComponent, pathMatch: 'full' },
    { path: 'NormogramaInstitucional', component: NormogramaInstitucionalComponent, pathMatch: 'full' },
    { path: 'PoliticaDeIntegridadYBuenGobierno', component: PoliticaDeIntegridadYBuenGobiernoComponent, pathMatch: 'full' },
    { path: 'CertificadoDeCalidadNTC', component: CertificadoDeCalidadNTCGComponent, pathMatch: 'full' },
    { path: 'CertificadoDeCalidadISO', component: CertificadoDeCalidadISOComponent, pathMatch: 'full' },
    { path: 'Contactenos', component: ContactenosComponent, pathMatch: 'full' },
   
   
   
    { path: 'Documentos', component: DocumentosComponent, pathMatch: 'full' },
    { path: 'Documentos/:id', component: DocumentosComponent, pathMatch: 'full' },
    
    { path: 'TramitesYServicios', component: TramitesYServiciosComponent, pathMatch: 'full' },
    { path: 'TramitesCiudadano', component: TramitesCiudadanoComponent, pathMatch: 'full' },
    { path: 'TramitesCiudadano/Detalle/:id', component: DetalleTramiteCComponent, pathMatch: 'full' },
    { path: 'CertificadoDeCalidadNTC2012', component: CertificadoCalidadNTCComponent, pathMatch: 'full' },
    

    { path: 'ConsultarPQRS/:id', component: PqrsConsultarComponent, pathMatch: 'full'},
    { path: 'ConsultarPQRS', component: PqrsConsultarComponent, pathMatch: 'full'},
    { path: 'ConsultarTramite', component: TramiteConsultaComponent, pathMatch: 'full' },
    
   
    { path: 'SistemaCOGUI', component: SistemaCoguiComponent, pathMatch: 'full'},

    { path: 'SensibilizacionYCapacitacion', component: SensibilizacionYCapacitacionComponent, pathMatch: 'full' },
    { path: 'Logros', component: LogrosComponent, pathMatch: 'full' },

    { path: 'CertificadosCalidad', component: CertificadosCalidadComponent, pathMatch: 'full' },
    { path: 'login', component: LoginComponent, pathMatch: 'full' },

    { path: 'Encuesta-PQRS/:id', component: EncuestaPqrsComponent, pathMatch: 'full' },
];
